// extracted by mini-css-extract-plugin
export default {"Compare":"CompareAssessmentModal_Compare__VkQ8w","CompareIcon":"CompareAssessmentModal_CompareIcon__QkbjZ"};